import type { Strategies } from '@fortem-monorepo/web-sdk'

import type { CreateStrategyValues } from './CreateStrategyForm/CreateStrategyForm.schema'
import type { UpdateStrategyValues } from './UpdateStrategyForm/UpdateStrategyForm.schema'
import type { StrategyValues } from './shared/strategy-values.schema'

// Call only with values validated by the operation's frontend form schema.
const toStrategyParams = (values: StrategyValues): Strategies.StrategyParams => ({
  strategy_name: values.strategy_name,
  strategy_type: values.strategy_type,
  is_internal: values.is_internal === 'true',
  active: values.active === 'true',
})

export const toCreateStrategyParams = (values: CreateStrategyValues): Strategies.CreateParams => ({
  ...toStrategyParams(values),
  currency_id: Number(values.currency_id),
})

export const toUpdateStrategyParams = (values: UpdateStrategyValues, strategyId: number): Strategies.UpdateParams => ({
  ...toStrategyParams(values),
  strategy_id: strategyId,
})
